<div class="grid grid-cols-[10%_80%_10%] items-center py-3 text-base" (click)="handleClick()">
    <ion-icon
        class="h-full w-full text-grey-zambezy dark:filter-yellow"
        aria-hidden="true"
        src="{{ assetsPath$ | async }}/img/journey-planner/origin-and-destination.svg"></ion-icon>
    <div
        class="grid gap-2"
        [attr.aria-label]="
            ('LOCAL_LABEL_FROM' | translate) +
            ' ' +
            (location?.origin === TRANSLATION_MAP[location?.origin]
                ? (TRANSLATION_MAP[location?.origin] | translate)
                : location?.origin) +
            ' ' +
            ('LOCAL_LABEL_TO' | translate) +
            ' ' +
            (location?.destination === TRANSLATION_MAP[location?.destination]
                ? (TRANSLATION_MAP[location?.destination] | translate)
                : location?.destination)
        "
        (click)="handleClick()"
        (keydown.enter)="handleClick()"
        role="button"
        tabindex="0">
        <div *ngIf="!location.origin">{{ 'ITINERARY_INSTRUCTIONS_DESTINATION' | translate | titlecase }}</div>
        <p class="overflow-hidden text-ellipsis whitespace-nowrap">
            {{
                location.origin === TRANSLATION_MAP[location.origin]
                    ? (TRANSLATION_MAP[location.origin] | translate)
                    : location.origin
            }}
            <span *ngIf="env.JOURNEY_PLANNER?.SHOW_MUNICIPALITY_IN_STOP_NAME && municipalityName?.origin"
                >({{ municipalityName.origin }})</span
            >
        </p>
        <div *ngIf="!location.destination">{{ 'ITINERARY_INSTRUCTIONS_DESTINATION' | translate | titlecase }}</div>
        <p class="overflow-hidden text-ellipsis whitespace-nowrap">
            {{
                location.destination === TRANSLATION_MAP[location.destination]
                    ? (TRANSLATION_MAP[location.destination] | translate)
                    : location.destination
            }}
            <span *ngIf="env.JOURNEY_PLANNER?.SHOW_MUNICIPALITY_IN_STOP_NAME && municipalityName?.destination"
                >({{ municipalityName.destination }})</span
            >
        </p>
    </div>
    <button
        *ngIf="isShowRemoveIcon"
        [attr.aria-label]="'REMOVE_FAVORITE_JOURNEY' | translate"
        (click)="handleRemove($event)"
        mat-icon-button>
        <mat-icon
            class="orb-app-light:text-red-600 orb-app-light:font-bold vl-app-light:text-red-600 vl-app-light:font-bold var-app-light:text-[var(--color-button-cross)] var-app-light:font-bold text-[1rem] text-lg text-primary"
            *ngIf="!useTrashIcon"
            >close
        </mat-icon>
        <!-- Trash Bin Icon (alternative) -->
        <mat-icon
            class="text-primary-danger !h-8 !w-8"
            *ngIf="useTrashIcon"
            svgIcon="trash-bin"
            aria-hidden="true"></mat-icon>
    </button>
</div>
